import { lazy } from "react";

export const BrandCatalogue = lazy(() => import("./BrandCatalogue"));
export const CreatorDetails = lazy(() => import("./CreatorDetails"));
export const BrandCompleteProfile = lazy(() => import("./BrandCompleteProfile"));
export const Welcome = lazy(() => import("./Welcome"));
// export const BrandChat = lazy(() => import("./BrandChat"));